export interface ButtonItem {
  buttonDescription: string,
  boardCode: string,
  boardDescription: string,
  plateNumber: string,
  buttonImage: string
}

export interface IButtonData {
  category: string,
  buttonUpdate: string,
  buttons: ButtonItem[]
}

export enum ButtonType {
  union = "Union - Category",
  sur = "Union - Surplus",
  casual = "Casual",
  tel = "Telephone",
}